import {
  faCopy,
  faEdit,
  faEllipsisVertical,
  faEye,
  faRotate,
  faTrash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Badge, Dropdown, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import AdminService from "../../services/admin.service";
import ResetPasswordModal from "../Modal/resetPassword.modal";
import CustomToggle from "../toggle/CustomToggle";
import moment from "moment";
import EditReverificationOperatorModal from "../Modal/EditReverificationOperator.modal";
import Spinner from 'react-bootstrap/Spinner';
import UploadUserSheetModal from "../Modal/UploadUserSheet.modal";
import { useNavigate, useNavigation } from "react-router";

interface IOperatorTable {
  operators: any;
  examId: any;
  reload: any;
}

const OperatorTable = ({ operators, examId, reload }: IOperatorTable) => {

  const navigate = useNavigate();


  const [showResetModal, setShowResetModal] = useState<any>(undefined);
  const [editOperator, setEditOperator] = useState<string>("");
  const [showRevificationModal, setShowReverificationModal] = useState<any>(undefined);

  const handleActiveToggle = async (id: any) => {
    await AdminService.toggleActiveUser(id)
      .then((res: any) => {
        if (res.status === 200) {
          toast.success("User Status Changed");
          reload();
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const handleDeleteOperator = async (id: any) => {
    await AdminService.deleteOperator(id)
      .then((res) => {
        if (res.status === 200) {
          reload();
          toast.success("operator deleted successfully");
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const handleResetPassword = async (id: any) => {
    await AdminService.resetPasswordForReverificationOperator(id)
      .then(res => {
        if (res.status === 200) {
          setShowResetModal(res.data);
          reload();
        }
      }).catch(err => {
        toast.error(err)
      })
  }

  return (
    <>
      <Table striped hover className="xcn-text-12">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th>
              <span className="fw-bold">Email</span>
            </th>
            <th>
              <span className="fw-bold">Userame</span>
            </th>
            <th>
              <span className="fw-bold">College ID</span>
            </th>
            <th>
              <span className="fw-bold">College Name</span>
            </th>
             {/* <th>
              <span className="fw-bold">Stream</span>
            </th> */}
            <th>
              <span className="fw-bold">Active</span>
            </th>
          </tr>
        </thead>
        {operators && operators.length > 0
          ? operators.map((client: any, index: number) => {
            return (
              <tr>
                <td>{index + 1}</td>
                <td>{client.emailId || "N/A"}</td>
                <td>{client.userName}</td>
                <td>{client?.collegId || "--"}</td>
                <td>{client?.collegeName || "--"}</td>
                {/* <td>{client?.stream || "--"}</td> */}
                <td
                  style={{ cursor: "pointer" }}
                  onClick={() => handleActiveToggle(client?._id)}
                >
                  {client?.isAllowed ? (
                    <Badge bg="success">Active</Badge>
                  ) : (
                    <Badge bg="danger">Blocked</Badge>
                  )}
                </td>

                <td>
                  <Dropdown>
                    <Dropdown.Toggle
                      as={CustomToggle}
                      id="dropdown-custom-components"
                    >
                      <FontAwesomeIcon icon={faEllipsisVertical} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>



                      <Dropdown.Item
                        onClick={() => setEditOperator(client?._id)}
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="text-primary me-2"
                        />
                        <span className="fw-bold">Edit</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => navigate("/dashboard/exam/" + examId + "/" + client?._id)}
                      >
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary me-2"
                        />
                        <span className="fw-bold">View Verification Users</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => setShowReverificationModal(client?._id)}
                      >
                        <FontAwesomeIcon
                          icon={faUpload}
                          className="text-secondary me-2"
                        />
                        <span className="fw-bold">Upload User Sheet</span>
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          window.navigator.clipboard.writeText(
                            client?.plainPassword
                          );
                          toast.success("Password copied to clipboard");
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faCopy}
                          className="text-success me-2"
                        />
                        <span className="fw-bold">Copy Password to clipboard</span>
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={() => handleResetPassword(client?._id)}>
                        <FontAwesomeIcon icon={faRotate} className="text-primary me-2" />
                        <span className="fw-bold">
                          Reset Password
                        </span>
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        onClick={() => handleDeleteOperator(client?._id)}

                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="text-danger me-2"
                        />
                        <span className="fw-bold">Delete</span>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })
          : "No operator found"}
        <tbody></tbody>
      </Table>
      <ResetPasswordModal
        show={showResetModal}
        handleClose={() => setShowResetModal(false)}
      />

      <UploadUserSheetModal
        show={showRevificationModal}
        handleClose={() => setShowReverificationModal(undefined)}
      />


      <EditReverificationOperatorModal
        userId={editOperator}
        handleClose={() => setEditOperator("")}
        reload={reload}
      />
    </>
  );
};

export default OperatorTable;
